/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getUserNotificationSetting } from '../../services/notification.service';
import { settingModuleArray, Page_Size } from '../../Components/helper';
import * as action from './store/notification.action';

export const StateContext = createContext(null);

export default function NotificationProvider({ children }) {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const initialSetting = {
    settingView: false,
    settingModuleArray,
    chatEmailEnabled: true,
    expandedPanel: [
      'productInformation',
      'designDetail',
      'bom',
      'specification',
      'testing',
      'userIntruction',
      'sample',
      'productCosting',
      'purchaseOrder',
      'document',
      'OCP',
      'PCP',
      'rangePlan',
      'PIM',
    ],
    userNotifications: [],
    pageIndex: 1,
    notLoader: false,
    hasMore: false,
    expandedItems: [],
  };
  const reducerState = useSelector((redState) => redState);
  const {
    UserNotificationDetails: { notificationList, totolCount },
  } = reducerState;
  const [notState, setNotificationState] = useState(initialSetting);

  const getNotificationList = async (obj) => {
    setNotificationState((prev) => ({
      ...prev,
      notLoader: true,
    }));
    await dispatch(action.fetchNotificationList(obj, t));
    setNotificationState((prev) => ({
      ...prev,
      notLoader: false,
    }));
  };

  const retriveNotificationSetting = async () => {
    const settings = await getUserNotificationSetting();
    if (!settings?.data) return;

    let modulesData;
    let chatEmailEnabled = true;

    if (Array.isArray(settings.data)) {
      modulesData = settings.data;
    } else if (settings.data && typeof settings.data === 'object' && 'notificationSettings' in settings.data) {
      modulesData = settings.data.notificationSettings;
      chatEmailEnabled = settings.data.chatEmailEnabled ?? true;
    } else {
      modulesData = settings.data;
    }

    if (Array.isArray(modulesData)) {
      const savedByModule = modulesData.reduce((acc, m) => {
        const key = m.moduleName?.toLowerCase();
        if (key) acc[key] = m;
        return acc;
      }, {});
      const merged = settingModuleArray?.length > 0 ? settingModuleArray?.map((defaultModule) => {
        const key = defaultModule.moduleName?.toLowerCase();
        const saved = key ? savedByModule[key] : null;
        return saved ? { ...defaultModule, ...saved } : { ...defaultModule };
      }) : settingModuleArray;
      setNotificationState((prev) => ({
        ...prev,
        settingModuleArray: merged,
        chatEmailEnabled,
      }));
    } else {
      setNotificationState((prev) => ({
        ...prev,
        settingModuleArray: modulesData,
        chatEmailEnabled,
      }));
    }
  };

  useEffect(() => {
    async function fetchData() {
      const reqObj = {
        pageIndex: notState.pageIndex,
        pageSize: Page_Size,
      };
      await getNotificationList(reqObj);
      await retriveNotificationSetting();
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (notificationList.length > 0) {
      setNotificationState((prev) => ({
        ...prev,
        hasMore: totolCount > notificationList?.length,
      }));
    }
  }, [notificationList?.length, totolCount]);

  const contextValue = useMemo(
    () => ({
      notState,
      setNotificationState,
      getNotificationList,
      retriveNotificationSetting,
    }),
    [notState, setNotificationState, getNotificationList, retriveNotificationSetting],
  );

  return (
    <StateContext.Provider
      value={{
        ...contextValue,
      }}
    >
      {children}
    </StateContext.Provider>
  );
}

export function useNotificationState() {
  const { t } = useTranslation('common');

  const context = useContext(StateContext);
  if (!context) {
    throw new Error(t('NOTIFICATION_NOT_FOUND.USE_APP_STATE_NOTIFICATION'));
  }
  return context;
}
